import Vue from "vue";
import Router from "vue-router";
import LoginPage from "../components/LoginPage.vue";
import ContentPage from "../components/ContentPage.vue";
import ProfilePage from "../components/ProfilePage.vue";
import LandingPage from "../components/LandingPage.vue";
import ListPage from "../components/ListPage.vue";
import CartPage from "../components/CartPage.vue";
import PromoPage from "../components/PromoPage.vue";
import PaymentPage from "../components/PaymentPage.vue";
import HeaderPage from "../components/HeaderPage.vue";
import FooterPage from "../components/FooterPage.vue";
import ConfirmPage from "../components/ConfirmPage.vue";
import OrderHistoryPage from "../components/OrderHistoryPage.vue";
import PromotionScreenPage from "../components/PromotionScreenPage.vue";
import PaypalPage from "../components/PaypalPage.vue";
import TranHistoryPage from "../components/TranHistoryPage.vue";

import AuthService from "../authService.js";
import config from "../config/config";

Vue.use(Router);
function lazyLoad(view) {
  return () => import(`@/components/${view}.vue`);
}

export const router = new Router({
  // mode:'history',

  routes: [
    {
      path: "/:token?",
      name: "login",
      component: lazyLoad("LoginPage"),
    }, //{
    // 		path: '/',
    // 		name: 'content',
    // 		component: ContentPage
    // 	},
    {
      path: "/content",
      name: "content",
      component: lazyLoad("ContentPage"),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "profile",
          name: "profile",
          component: lazyLoad("ProfilePage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "paypal",
          name: "paypal",
          component: lazyLoad("PaypalPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "landing",
          name: "landing",
          component: lazyLoad("LandingPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "list",
          name: "list",
          component: lazyLoad("ListPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "orderhistory",
          name: "orderhistory",
          component: lazyLoad("OrderHistoryPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "promotionscreen",
          name: "promotionscreen",
          component: lazyLoad("PromotionScreenPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "cart",
          name: "cart",
          component: lazyLoad("CartPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "promo",
          name: "promo",
          component: lazyLoad("PromoPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "payment",
          name: "payment",
          component: lazyLoad("PaymentPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "header",
          name: "header",
          component: lazyLoad("HeaderPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "footer",
          name: "footer",
          component: lazyLoad("FooterPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "confirm",
          name: "confirm",
          component: lazyLoad("ConfirmPage"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "transactions",
          name: "transactions",
          component: lazyLoad("TranHistoryPage"),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});
// router.beforeEach((to, from, next) => {
// 	// const authService = new AuthService();
// 	const auth = new AuthService();

// let app = router.app.$data || {isAuthenticated: false}
//   if (app.isAuthenticated) {
//     //already signed in, we can navigate anywhere
//     next()
//   } else if (to.matched.some(record => record.meta.requiresAuth)) {
// 	next();
//     //authentication is required. Trigger the sign in process, including the return URI
//     //let authenticate = router.app.authenticate
//     // authenticate(to.path).then(() => {
//     //   console.log('authenticating a protected url:' + to.path);
//     //   next();
//     // });
//   } else {
//     //No auth required. We can navigate
//     next()
//   }
//   });
export default router;
